<fieldset class="section-legend-border col-md-12 col-lg-12" #HabitCategory >
  <legend class="section-legend-border">Habit Category</legend>
<div id="main-category-section">
<div class="row">
  <div class="col-sm-12">
    <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <div class="form-row">
        <div class="form-group col-md-6">
          <ng-template #rt let-r="result" let-t="term">
            {{ r.HabitCategoryName}}
          </ng-template>
          <label for="typeahead-basic">Search for a Habit Category Name:</label>
          <input id="typeahead-basic" type="text" class="form-control" name="habitCategoryModel.HabitCategoryAutoComplete" 
          [(ngModel)]="habitCategoryModel.HabitCategoryAutoComplete" [ngbTypeahead]="search" [inputFormatter]="formatter"
          [resultTemplate]="rt" (selectItem)="selectedItem($event)"
          />
        </div>
      </div>
      <div class="form-row"> 
        <div class="form-group col-md-3">
          <label for="disabledTextInput">Habit Category Id</label>
          <input type="text" [(ngModel)]="habitCategoryModel.HabitCategoryId" name="habitCategoryModel.HabitCategoryId" placeholder="Habit Category Id" class="form-control">
        </div>
        <div class="form-group col-md-3">
          <label for="disabledTextInput">Habit Category Name</label>
          <input type="text" [(ngModel)]="habitCategoryModel.HabitCategoryName" name="habitCategoryModel.HabitCategoryName" placeholder="Habit Category Name" class="form-control">
        </div>

      </div>
      <div class="form-row">
        <div class="col-md-1"></div>
        <div class="form-group col-md-4 col-sm-12">
          <button type="submit" class="btn btn-primary btn-block">Submit</button>
        </div>
      </div>
    </form> 
  </div>
  <div class="col-sm-12">
    {{result}}
  </div>
  </div>  
</div>
</fieldset>
  <!-- <pre>Model: {{ habitCategoryModel.HabitAutoComplete | json }}</pre> -->